document.addEventListener('DOMContentLoaded', function () {

  // Menú móvil
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var isOpen = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
    document.querySelectorAll('.nav-item').forEach(function (item) {
      var link = item.querySelector('.has-dropdown');
      if (link) {
        link.addEventListener('click', function (e) {
          if (window.innerWidth < 900) {
            e.preventDefault();
            item.classList.toggle('is-open');
          }
        });
      }
    });
  }

  // Buscador
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.querySelector('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      searchBar.hidden = !searchBar.hidden;
      if (!searchBar.hidden) searchBar.querySelector('input').focus();
    });
  }

  // Galería de producto: miniaturas
  document.querySelectorAll('.thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg) mainImg.src = thumb.getAttribute('data-thumb-src');
    });
  });

  // Selector de variantes -> selecciona la opción real en el <select> oculto y lo envía
  var variantSelect = document.querySelector('[data-variant-select]');
  var addToCartBtn = document.querySelector('[data-add-to-cart]');
  document.querySelectorAll('.option-pill input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      var selectedValues = {};
      form.querySelectorAll('.option-pill input:checked').forEach(function (checked) {
        selectedValues[checked.getAttribute('data-option-index')] = checked.value;
      });
      if (!variantSelect) return;
      var options = variantSelect.querySelectorAll('option');
      var matched = null;
      options.forEach(function (opt) {
        var parts = opt.textContent.trim().split(' / ');
        var isMatch = Object.keys(selectedValues).every(function (idx) {
          return parts[idx - 1] === selectedValues[idx];
        });
        if (isMatch) matched = opt;
      });
      if (matched) {
        variantSelect.value = matched.value;
        if (addToCartBtn) addToCartBtn.disabled = matched.disabled;
      }
    });
  });

  // Guía de tallas
  var sizeGuideTrigger = document.querySelector('[data-size-guide-open]');
  var sizeGuideModal = document.querySelector('[data-size-guide-modal]');
  if (sizeGuideTrigger && sizeGuideModal) {
    sizeGuideTrigger.addEventListener('click', function () { sizeGuideModal.hidden = false; });
    sizeGuideModal.querySelectorAll('[data-size-guide-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { sizeGuideModal.hidden = true; });
    });
  }

  // Barra de envío gratis
  var bar = document.querySelector('[data-free-shipping-bar]');
  if (bar) {
    var threshold = parseFloat(bar.getAttribute('data-threshold')) || 450000;
    var current = (parseFloat(bar.getAttribute('data-current')) || 0) / 100; // cart.total_price viene en centavos
    var fill = bar.querySelector('.free-shipping-bar__fill');
    var message = bar.querySelector('.free-shipping-bar__message');
    var pct = Math.min((current / threshold) * 100, 100);
    if (fill) fill.style.width = pct + '%';
    if (message) {
      if (current >= threshold) {
        message.textContent = '¡Tu pedido tiene envío gratis!';
      } else {
        var missing = threshold - current;
        var formatted = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(missing);
        message.textContent = 'Te faltan ' + formatted + ' para obtener envío gratis.';
      }
    }
  }

  // Wishlist básica (localStorage) — punto de partida; se reemplaza por la app elegida en Fase 6/9
  document.querySelectorAll('[data-wishlist-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-product-id');
      var saved = JSON.parse(localStorage.getItem('amaella_wishlist') || '[]');
      if (!saved.includes(id)) {
        saved.push(id);
        localStorage.setItem('amaella_wishlist', JSON.stringify(saved));
        btn.classList.add('is-active');
      }
    });
  });

});
